import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Link, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "react-select";

import useRequest from "../../hooks/useRequest";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import GooglePlace from "../GooglePlace";

import {
  Input,
  SelectInput,
  MultiReactSelectInput,
  RenderInputFields,
  SubmitButton,
  PhoneNumber,
} from "../Form/Form";

const Add = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    control,
  } = useForm();

  const history = useHistory();

  const imgArray = ["image/png", "image/jpeg", "image/jpg"];

  const [image, setImage] = useState("");
  const [businessImage, setBusinessImage] = useState("");
  const [positionData, setPositionData] = useState([]);
  const [carBrand, setCarBrand] = useState([]);
  // const [country, setCountry] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [personalCity, setPersonalCity] = useState("");
  const [businessCity, setBusinessCity] = useState("");

  const { response, request } = useRequest();
  const { response: positionRes, request: positionReq } = useRequest();
  const { response: brandRes, request: brandReq } = useRequest();
  const { response: citySearchRes, request: citySearchReq } = useRequest();
  // const { response: countryRes, request: countryReq } = useRequest();

  useEffect(() => {
    positionReq("GET", "position");
    brandReq("GET", "brand");
    citySearchReq("GET", `city/get-all`);
    // countryReq("GET", "country/get-all-countries");
  }, []);

  useEffect(() => {
    if (response) {
      toast.success("Vendor has been added successfully.");
      history.push("/stores");
    }
  }, [response]);

  useEffect(() => {
    if (citySearchRes) {
      const arr = [];
      if (citySearchRes?.cities.length > 0) {
        citySearchRes?.cities?.map((val) =>
          arr.push({
            value: val._id,
            label: val.name,
          })
        );
        setCityList(arr);
      }
    }
  }, [citySearchRes]);

  // useEffect(() => {
  //   if (countryRes) {
  //     setCountry(countryRes.countries);
  //   }
  // }, [countryRes]);

  useEffect(() => {
    if (positionRes) {
      setPositionData(positionRes.data);
    }
  }, [positionRes]);

  useEffect(() => {
    if (brandRes) {
      setCarBrand(brandRes.data);
    }
  }, [brandRes]);

  const displayImageHandler = (e) => {
    setImage(URL.createObjectURL(e.target.files[0]));
  };

  const displayBusinessImageHandler = (e) => {
    setBusinessImage(URL.createObjectURL(e.target.files[0]));
  };
  const handleRemoveMedia = () => {
    setValue("profilePic", "");
    setImage("");
    setBusinessImage("");
  };

  const handleRemoveBusinessMedia = () => {
    setValue("businessProfile", "");
    setBusinessImage("");
  };
  const saveAddressHandler = (address, geoLocation, key) => {
    setValue("address", address);
  };
  const businessAddressHandler = (address, geoLocation, key) => {
    setValue("businessAddress", address);
  };

  const customOtherLoactionDetailHandler = (
    country,
    postalCode,
    // city,
    state,
    key
  ) => {
    setValue("country", country);
    // setValue("city", city);
    setValue("state", state);
    setValue("postal_code", postalCode);
  };
  const businessOtherLoactionDetailHandler = (
    businessCountry,
    business_postal_code,
    // businessCity,
    businessState,
    key
  ) => {
    setValue("businessCountry", businessCountry);
    // setValue("businessCity", businessCity);
    setValue("businessState", businessState);
    setValue("business_postal_code", business_postal_code);
  };

  const onSubmit = (data) => {
    let {
      address,
      businessName,
      businessState,
      businessAddress,
      businessCountry,
      contact,
      carBrand,
      countryCode,
      dob,
      businessProfile,
      email,
      business_postal_code,
      firstName,
      lastName,
      position,
      postal_code,
      profilePic,
      state,
      country,
    } = data;

    let itemArray = [];

    if (email) {
      email = email.toLowerCase();
    }

    carBrand.map((item) => {
      itemArray.push(`${item.value}`);
    });

    const formData = new FormData();
    formData.append("firstName", firstName);
    formData.append("lastName", lastName);
    formData.append("email", email);
    formData.append("contact", contact.replace(countryCode, ""));
    formData.append("countryCode", countryCode);
    // formData.append("dob", dob);
    // formData.append("city", city);
    if (personalCity) {
      formData.append("city", personalCity);
    }
    formData.append("state", state);
    formData.append("address", address);
    formData.append("country", country);
    formData.append("postal_code", postal_code);

    formData.append("businessName", businessName);
    formData.append("position", position);
    formData.append("carBrand", JSON.stringify(itemArray));
    // formData.append("businessCity", businessCity);
    if (businessCity) {
      formData.append("businessCity", businessCity);
    }
    formData.append("businessState", businessState);
    formData.append("businessAddress", businessAddress);
    formData.append("businessCountry", businessCountry);
    formData.append("business_postal_code", business_postal_code);

    if (profilePic && profilePic[0]) {
      const profilePicType = profilePic[0].type;
      if (!imgArray.includes(profilePicType)) {
        toast.error("Please select image only in profile pic");
        return;
      } else {
        formData.append("profilePic", profilePic[0]);
      }
    }

    if (businessProfile && businessProfile[0]) {
      const profilePicType = businessProfile[0].type;
      if (!imgArray.includes(profilePicType)) {
        toast.error("Please select image only in document");
        return;
      } else {
        formData.append("businessProfile", businessProfile[0]);
      }
    }

    request("POST", "vendor/create", formData);
  };

  const InputFields = [
    [
      {
        Component: Input,
        label: "First Name",
        type: "text",
        name: "firstName",
        registerFields: {
          required: true,
          pattern: /^[A-Za-z]+$/,
          onChange: (v) =>
            setValue("firstName", v.target.value.replace(/[^a-zA-Z]/g, "")),
        },
        registerFieldsFeedback: {
          pattern: "First Name can only contain letters.",
        },
      },
      {
        Component: Input,
        label: "Last Name",
        type: "text",
        name: "lastName",
        registerFields: {
          required: true,
          pattern: /^[A-Za-z]+$/,
          onChange: (v) =>
            setValue("lastName", v.target.value.replace(/[^a-zA-Z]/g, "")),
        },
        registerFieldsFeedback: {
          pattern: "Last Name can only contain letters.",
        },
      },
      {
        Component: Input,
        label: "Email",
        type: "email",
        name: "email",
        registerFields: {
          required: true,
          pattern: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
          setValueAs: (v) => v.trim(),
        },
        registerFieldsFeedback: {
          pattern: "The email field must be a valid email address.",
        },
      },
      {
        Component: PhoneNumber,
        label: "Contact",
        type: "number",
        name: "contact",
        control: control,
        setValue: setValue,
        registerFields: {
          required: true,
          pattern: {
            value: /^[0-9][0-9]{7,14}$/,
          },
        },
        registerFieldsFeedback: {
          pattern: "Please enter valid 8-15 digit contact number.",
        },
      },
      // {
      //   Component: Input,
      //   label: "DOB",
      //   type: "date",
      //   name: "dob",
      //   isDate: true,
      //   control: control,
      //   max: new Date().toISOString().split("T")[0],
      //   min: "1970-01-01",
      //   registerFields: {
      //     required: false,
      //   },
      // },
      {
        Component: Input,
        label: "Profile Pic",
        type: "file",
        name: "profilePic",
        registerFields: {
          required: false,
        },
        handleMedia: displayImageHandler,
        isMedia: true,
        accept: ".png, .jpg, .jpeg",
        control,
        children: image && (
          <>
            <img
              src={image}
              width={150}
              height={100}
              alt=""
              style={{ cursor: "pointer", marginBottom: "10px" }}
              data-fancybox
            />
            <Link to="#" onClick={handleRemoveMedia} className="mx-3">
              Remove
            </Link>
          </>
        ),
      },
      // {
      //   Component: SelectInput,
      //   label: "Country",
      //   name: "country",
      //   registerFields: {
      //     required: true,
      //   },
      //   children: (
      //     <>
      //       <option value="">Select</option>
      //       {country?.map((item) => {
      //         return (
      //           <option key={item._id} value={item.value}>
      //             {item.label}
      //           </option>
      //         );
      //       })}
      //     </>
      //   ),
      // },
    ],
  ];

  const InputFieldsBusiness = [
    [
      {
        Component: Input,
        label: "Business Name",
        type: "text",
        name: "businessName",
        registerFields: {
          required: true,
        },
      },
      {
        Component: SelectInput,
        label: "Position",
        name: "position",
        registerFields: {
          required: true,
        },
        children: (
          <>
            <option value="">Select</option>
            {positionData.map((item) => {
              return (
                <option key={item._id} value={item._id}>
                  {item.name}
                </option>
              );
            })}
          </>
        ),
      },
      {
        Component: MultiReactSelectInput,
        label: "Car Brand",
        name: "carBrand",
        className: "form-control",
        registerFields: {
          required: true,
        },
        control: control,
        isMultiple: true,
        options:
          carBrand &&
          carBrand.map((item) => {
            return { value: item._id, label: item.name };
          }),

        // children: (
        //   <>
        //     <option value="">Select</option>
        //     {carBrand.map((item) => {
        //       return (
        //         <option key={item._id} value={item._id}>
        //           {item.name}
        //         </option>
        //       );
        //     })}
        //   </>
        // ),
      },
      {
        Component: Input,
        label: "Document",
        type: "file",
        name: "businessProfile",
        colClass: "col-6",
        registerFields: {
          required: false,
        },
        handleMedia: displayBusinessImageHandler,
        isMedia: true,
        accept: ".png, .jpg, .jpeg",
        control,
        children: businessImage && (
          <>
            <img
              src={businessImage}
              width={150}
              height={100}
              alt=""
              style={{ cursor: "pointer", marginBottom: "10px" }}
              data-fancybox
            />
            <Link to="#" onClick={handleRemoveBusinessMedia} className="mx-3">
              Remove
            </Link>
          </>
        ),
      },
      // {
      //   Component: SelectInput,
      //   label: "Country",
      //   name: "businessCountry",
      //   registerFields: {
      //     required: true,
      //   },
      //   children: (
      //     <>
      //       <option value="">Select</option>
      //       {country?.map((item) => {
      //         return (
      //           <option key={item._id} value={item.value}>
      //             {item.label}
      //           </option>
      //         );
      //       })}
      //     </>
      //   ),
      // },
    ],
  ];

  return (
    <div
      className="content  d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Breadcrumb
        title="Store"
        links={[
          { to: "/", name: "Dashboard" },
          { to: "/stores", name: "Back To stores" },
        ]}
      />

      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="card card-custom">
            <div className="card-header">
              <h3 className="card-title">Add New Store</h3>
            </div>

            <div className="card-body">
              <div className="row">
                <div className="col-xl-12">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="accordion" id="accordionExample">
                      <div className="card">
                        <div className="card-header" id="headingOne">
                          <h2 className="mb-0">
                            <button
                              className="btn btn-link btn-block text-left"
                              type="button"
                              data-toggle="collapse"
                              data-target="#collapseOne"
                              aria-expanded="true"
                              aria-controls="collapseOne"
                            >
                              Personal Details
                            </button>
                          </h2>
                        </div>

                        <div
                          id="collapseOne"
                          className="collapse show"
                          aria-labelledby="headingOne"
                          data-parent="#accordionExample"
                        >
                          <div className="card-body">
                            <RenderInputFields
                              InputFields={InputFields}
                              errors={errors}
                              register={register}
                            />
                            <div className="row">
                              <div className="col-lg-6">
                                <div className="form-group">
                                  <div className="form-input-box">
                                    <label className="form-label">
                                      Address
                                    </label>
                                    <GooglePlace
                                      saveAddress={saveAddressHandler}
                                      setValue={setValue}
                                      defaultAddress={""}
                                      customOtherLoactionDetailHandler={
                                        customOtherLoactionDetailHandler
                                      }
                                      type="personal"
                                    />
                                  </div>
                                </div>
                              </div>
                              {/* <div className="col-lg-6">
                                <div className="form-group">
                                  <div className="form-input-box">
                                    <label className="form-label">
                                      Country
                                    </label>
                                    <input
                                      type="text"
                                      name="country"
                                      className="form-control"
                                      {...register("country")}
                                    />
                                  </div>
                                </div>
                              </div> */}
                              <div className="col-lg-6">
                                <div className="form-group">
                                  {/* <div className="form-input-box"> */}
                                  <label
                                  // className="form-label"
                                  >
                                    City
                                  </label>
                                  {/* <input
                                      type="text"
                                      name="city"
                                      className="form-control"
                                      {...register("city")}
                                    /> */}
                                  <Controller
                                    className="select-reactSelect  form-control-solid"
                                    control={control}
                                    rules={{ required: false, minLength: 1 }}
                                    name="city"
                                    placeholder=""
                                    render={({
                                      field: { onChange, value, ref },
                                    }) => (
                                      <Select
                                        options={cityList}
                                        value={value}
                                        className="select-reactSelect form-control-solid"
                                     
                                        onChange={(e) => {
                                          setPersonalCity(e.label);
                                        }}
                                      />
                                    )}
                                  />
                                  {/* </div> */}
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="form-group">
                                  <div className="form-input-box">
                                    <label className="form-label">State</label>
                                    <input
                                      type="text"
                                      name="state"
                                      className="form-control"
                                      {...register("state")}
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="form-group">
                                  <div className="form-input-box">
                                    <label className="form-label">
                                      Zipcode
                                    </label>
                                    <input
                                      type="text"
                                      name="postal_code"
                                      className="form-control"
                                      {...register("postal_code")}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card">
                        <div className="card-header" id="headingTwo">
                          <h2 className="mb-0">
                            <button
                              className="btn btn-link btn-block text-left"
                              type="button"
                              data-toggle="collapse"
                              data-target="#collapseTwo"
                              aria-expanded="true"
                              aria-controls="collapseTwo"
                            >
                              Business Details
                            </button>
                          </h2>
                        </div>

                        <div
                          id="collapseTwo"
                          className="collapse show"
                          aria-labelledby="headingTwo"
                          data-parent="#accordionExample"
                        >
                          <div className="card-body">
                            <RenderInputFields
                              InputFields={InputFieldsBusiness}
                              errors={errors}
                              register={register}
                            />
                            <div className="row">
                              <div className="col-lg-6">
                                <div className="form-group">
                                  <div className="form-input-box">
                                    <label className="form-label">
                                      Address
                                    </label>
                                    <GooglePlace
                                      saveAddress={businessAddressHandler}
                                      // index={t}
                                      setValue={setValue}
                                      defaultAddress={""}
                                      businessOtherLoactionDetailHandler={
                                        businessOtherLoactionDetailHandler
                                      }
                                      type="business"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="form-group">
                                  <div className="form-input-box">
                                    <label className="form-label">City</label>
                                    {/* <input
                                      type="text"
                                      name="businessCity"
                                      className="form-control"
                                      {...register(`businessCity`)}
                                    /> */}

                                    <Controller
                                      control={control}
                                      rules={{ required: false, minLength: 1 }}
                                      name="businessCity"
                                      className="form-control"
                                      render={({
                                        field: { onChange, value, ref },
                                      }) => (
                                        <Select
                                          options={cityList}
                                          value ={value}
                                          onChange={(e) => {
                                            setBusinessCity(e.value);
                                          }}
                                        />
                                      )}
                                    />
                                  </div>
                                </div>
                              </div>
                              {/* <div className="col-lg-6">
                                <div className="form-group">
                                  <div className="form-input-box">
                                    <label className="form-label">
                                      Country
                                    </label>
                                    <input
                                      type="text"
                                      name="businessCountry"
                                      className="form-control"
                                      {...register(`businessCountry`)}
                                    />
                                  </div>
                                </div>
                              </div> */}
                              <div className="col-lg-6">
                                <div className="form-group">
                                  <div className="form-input-box">
                                    <label className="form-label">State</label>
                                    <input
                                      type="text"
                                      name="businessState"
                                      className="form-control"
                                      {...register(`businessState`)}
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="form-group">
                                  <div className="form-input-box">
                                    <label className="form-label">
                                      Zipcode
                                    </label>
                                    <input
                                      type="text"
                                      name="business_postal_code"
                                      className="form-control"
                                      {...register(`business_postal_code`)}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row"></div>

                    <SubmitButton
                      handleSubmit={handleSubmit}
                      onSubmit={onSubmit}
                      name="Submit"
                    />
                  </form>
                </div>
                <div className="col-xl-1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Add;
